export enum WidgetSize {
    Small = 'small',
    Medium = 'medium',
    Large = 'large',
}

export type RankingInfo = 'value' | 'position' | 'percentile' | 'icon';